import React, { Component } from 'react'
import T from 'prop-types'
import classnames from 'classnames'
import moment from 'moment'
import FuncHelper from 'helpers/functions'
import 'styles/app/filter-week.scss'
import { isTuesdayOrAfter } from 'helpers/seaLice'
import DashboardSchema from './Theme/Dashboard'
import FilterSchema from './Theme/Filter'

const CURRENT_WEEK = moment().week()
const CURRENT_YEAR = moment().year()
const schemas = {
  dashboard: DashboardSchema,
  filter: FilterSchema,
}

class WeekPicker extends Component {
  constructor(props) {
    super(props)
    this.state = this.initState()
  }

  componentDidUpdate(prevProps, prevState) {
    const { lastDate, firstDate } = this.state

    if (prevState.firstDate !== firstDate || prevState.lastDate !== lastDate) {
      this.props.onChange({ firstDate, lastDate })
    }
  }

  initState = () => {
    const state = {
      isDisablePrevYear: false,
      isDisableNextYear: true,
      isDisablePrevWeek: false,
      isDisableNextWeek: true,
      firstDate: this.props.activeWeek.firstDate,
      lastDate: this.props.activeWeek.lastDate,
    }

    state.currentDate = moment(state.lastDate * 1000)
    state.currentYear = state.currentDate.format('YYYY')
    state.currentMonth = state.currentDate.format('MMMM')
    state.currentWeek = state.currentDate.clone().subtract(1, 'days').week()

    return state
  }

  onChronologyNavigate = e => {
    const { nav, navStep } = e.currentTarget.dataset
    const { currentWeek, lastDate } = this.state

    if (!nav || !navStep) {
      return false
    }

    let state = {
      currentDate: moment(lastDate * 1000),
    }

    if (nav === 'prev') {
      state.currentDate.subtract(1, navStep)
    } else {
      state.currentDate.add(1, navStep)
    }

    const nextWeek = state.currentDate.clone().subtract(1, 'days').week()
    const prevWeek = currentWeek

    if (navStep === 'years' && nextWeek !== prevWeek) {
      if (nextWeek > prevWeek) {
        state.currentDate.subtract(nextWeek - prevWeek, 'weeks')
      } else {
        state.currentDate.add(prevWeek - nextWeek, 'weeks')
      }
    }

    state.firstDate = state.currentDate.clone().startOf('isoWeek').unix()
    state.lastDate = state.currentDate.clone().endOf('isoWeek').unix()
    state.currentYear = state.currentDate.clone().format('YYYY')
    state.currentMonth = state.currentDate.clone().format('MMMM')
    state.currentWeek = state.currentDate.clone().subtract(1, 'days').week()

    const stateYear = state.currentDate.year()
    const stepSize = isTuesdayOrAfter ? 1 : 2
    state.isDisableNextYear = stateYear + 1 > CURRENT_YEAR
    state.isDisableNextWeek =
      stateYear >= CURRENT_YEAR && state.currentWeek + stepSize >= CURRENT_WEEK

    if (stateYear === CURRENT_YEAR && state.currentWeek >= CURRENT_WEEK) {
      state = this.initState()
    }

    this.setState(state)
  }

  prevWeek = week => {
    const weekNumber = week - 1

    return weekNumber === 0 ? 52 : weekNumber
  }

  nextWeek = week => (week + 1 === 53 ? 1 : week + 1)

  prevYear = () => parseInt(this.state.currentYear, 10) - 1

  nextYear = () => parseInt(this.state.currentYear, 10) + 1

  render() {
    const { isOpen, schema } = this.props
    const Interface = schemas[schema]
    const props = {
      toggleClasses: classnames({ 'is-active': isOpen }),
      prevWeek: this.prevWeek,
      nextWeek: this.nextWeek,
      prevYear: this.prevYear,
      nextYear: this.nextYear,
      onChronologyNavigate: this.onChronologyNavigate,
      ...this.state,
    }

    return <Interface {...props} />
  }
}

WeekPicker.defaultProps = {
  activeWeek: {
    firstDate: moment().startOf('isoWeek').subtract(1, 'weeks').unix(),
    lastDate: moment().endOf('isoWeek').subtract(1, 'weeks').unix(),
  },
  isOpen: true,
  onChange: FuncHelper.emptyFunc,
  schema: 'dashboard',
}

WeekPicker.propTypes = {
  activeWeek: T.object,
  isOpen: T.bool,
  onChange: T.func,
  schema: (props, propName, componentName) => {
    if (!schemas.hasOwnProperty(props[propName])) {
      return new Error(
        `Invalid prop '${propName}' supplied to ${componentName}. Required values (${Object.keys(
          schemas,
        ).join(' | ')})`,
      )
    }
  },
}

export default WeekPicker
